import { PAYMENTS } from "../actions/types";

const initialize = {
  networks: [],
  dataProviders: [],
  dataSubscriptions: [],
  tvProviders: [],
  tvSubscriptions: [],
  electricitySubscriptions: []
};

const paymentsReducer = (state = initialize, { type, payload }) => {
  switch (type) {
    case PAYMENTS.FETCH_NETWORK_SUCCESS:
      return { ...state, networks: payload };

    case PAYMENTS.FETCH_DATA_PROVIDER_SUCCESS:
      return { ...state, dataProviders: payload };

    case PAYMENTS.FETCH_DATA_SUBSCRIPTION_SUCCESS:
      return { ...state, dataSubscriptions: payload };

    case PAYMENTS.FETCH_TV_PROVIDERS_SUCCESS:
      return { ...state, tvProviders: payload };

    case PAYMENTS.FETCH_TV_SUBSCRIPTIONS_SUCCESS:
      return { ...state, tvSubscriptions: payload };
    
    case PAYMENTS.FETCH_ELECTRICITY_SUB_SUCCESS:
      return {...state, electricitySubscriptions: payload}

    default:
      return state;
  }
};

export default paymentsReducer;
